import { FilterData } from "@/components/FilterBar/typing";
import { createLocalStorageOnce } from "@/utils/createLocalStorageOnce";

export const alertFlightFilterStorage =
  createLocalStorageOnce<Partial<FilterData>>("alert-flight-filter");
